export enum CandidateError {
  CandidateAlreadyHasPhoneNumber = 'Candidate already has a phone number',
  NoPhoneReminderAlreadySentToday = 'ra.message.noPhoneReminderAlreadySentToday',
}
